module.exports = __webpack_public_path__ + "media/assets/icons/close-white-aaff142c83a3207620a24ddab0def0fe.png";